import { isArray } from 'util';
import { ZollerMode } from '../zoller-mode';

export class ZollerModeBuilder {
  static fromJson(json) {
    return (json)
      ? new ZollerMode(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ZollerModeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/zoller-mode.builder.ts